module.exports = __webpack_public_path__ + "img/Info.28f934ab.svg";